import { render, staticRenderFns } from "./ComponentPositionRec.vue?vue&type=template&id=55f0325c"
import script from "./ComponentPositionRec.vue?vue&type=script&lang=js"
export * from "./ComponentPositionRec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports